'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024160 from "./presto.types$$anon$160.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dError$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Error-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$159() {
  this.cd1 = null;
  this.ccT = null;
  this.ccU = false;
  this.cd2 = null;
  this.cd3 = false;
  this.cd6 = null;
  this.ccZ = null;
  this.cd0 = false;
  this.ccV = null;
  this.ccW = false;
  this.ccX = null;
  this.ccY = false;
  this.cd4 = false;
  this.cd5 = false;
  this.cd1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cd6 = "TwoFactorAuthErrorPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$159.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$159;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$159() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$159.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.cd1;
});
$p.L = (function() {
  if ((!this.ccU)) {
    this.ccT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.ccU = true;
  }
  return this.ccT;
});
$p.O = (function() {
  if ((!this.cd3)) {
    this.cd2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.cd3 = true;
  }
  return this.cd2;
});
$p.E = (function() {
  return this.cd6;
});
$p.t = (function() {
  if ((!this.cd0)) {
    this.ccZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("message", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cd0 = true;
  }
  return this.ccZ;
});
$p.M = (function() {
  if ((!this.ccW)) {
    this.ccV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccW = true;
  }
  return this.ccV;
});
$p.Q = (function() {
  if ((!this.ccY)) {
    this.ccX = new $j_presto$002etypes$0024$0024anon$0024160.$c_Lpresto_types$$anon$160();
    this.ccY = true;
  }
  return this.ccX;
});
$p.w = (function() {
  if ((!this.cd5)) {
    this.cd4 = false;
    this.cd5 = true;
  }
  return this.cd4;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee183) => ((p) => \u03b4scrutinee183.cGI(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dError$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthErrorPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$159, "presto.types$TwoFactorAuthPayload$$anon$159", ({
  a2o: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$159.js.map
